// src/components/Maintenance/TaskTableToolbar.jsx

import React from 'react';
import { Button } from "../ui/button";

const TaskTableToolbar = ({ filter, setFilter }) => {
  return (
    <div className="flex flex-wrap gap-4 items-center justify-between mb-4">
      <div className="flex gap-2">
        <Button
          variant={filter === 'all' ? 'default' : 'outline'}
          onClick={() => setFilter('all')}
        >
          🗂 All
        </Button>
        <Button
          variant={filter === 'open' ? 'default' : 'outline'}
          onClick={() => setFilter('open')}
        >
          🟡 Open
        </Button>
        <Button
          variant={filter === 'closed' ? 'default' : 'outline'}
          onClick={() => setFilter('closed')}
        >
          ✅ Closed
        </Button>
      </div>
    </div>
  );
};

export default TaskTableToolbar;
